import { NotificationLogoProps } from ".";
import { CustomerTransactionPayload } from "@lib/types/Notification";
import { MdPayments } from "react-icons/md";
import { AppAvatar } from "@lib/components/AppComponents";
import {
  CustomerLogo,
  ProviderLogo,
} from "@lib/components/MiniComponents/Others";
import { useTypedSelector } from "@lib/redux";
import { AuthRoles } from "@lib/types";

export default function CustomerTransactionRequestLogo(
  props: NotificationLogoProps,
) {
  const { role } = useTypedSelector((state) => state.auth?.user);
  const { notification, onlyIcon = false } = props;
  const payload = notification.payload as CustomerTransactionPayload;
  const customer = { ...payload?.customer, ...payload?.transaction?.customer };
  const provider = { ...payload?.provider, ...payload?.transaction?.provider };

  if (onlyIcon || role !== AuthRoles.Admin) {
    return <MdPayments />;
  }

  return (
    <AppAvatar.Group>
      <CustomerLogo customer={customer} size={"x-small"} />
      <ProviderLogo provider={provider} size={"x-small"} />
    </AppAvatar.Group>
  );
}
